/*
 * rheincool — Abschnitt „Wichtige Hinweise" (sections/legal-notes.liquid)
 *
 * Der Abschnitt steht zugeklappt (Haendlerwunsch 06.09.2026). Ohne dieses
 * Modul landete der Kunde nach einem Klick auf „Wichtige Hinweise" in der
 * Reiterleiste auf einer geschlossenen Ueberschrift und muesste ein zweites
 * Mal klicken. Hier wird der Block deshalb geoeffnet, wenn
 *   1. der Anker in der Reiterleiste geklickt wird (data-target-class),
 *   2. die Seite mit #wichtige-hinweise aufgerufen wird,
 *   3. jemand die Seite durchsucht (Strg+F oeffnet details nicht von selbst —
 *      dafuer sorgt in modernen Browsern hidden="until-found", das hier nicht
 *      gesetzt werden kann, weil details/summary bereits die Semantik traegt).
 *
 * Ohne JavaScript bleibt der Abschnitt bedienbar: details/summary klappt von
 * sich aus auf.
 */
class RcLegalNotes extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.zielKlasse = 'section-legal-notes';
    this.onClick = (event) => {
      const link = event.target.closest('[data-anchor-link]');
      if (!link || link.dataset.targetClass !== this.zielKlasse) return;
      this.details.open = true;
    };
    document.addEventListener('click', this.onClick);

    if (window.location.hash === '#' + this.details.id) this.details.open = true;
  }

  disconnectedCallback() {
    if (this.onClick) document.removeEventListener('click', this.onClick);
  }
}

customElements.define('rc-legal-notes', RcLegalNotes);
